import * as React from 'react';
import { SEO } from '@/constants/wxHomepage';
import { genBlock } from '@/utils/bem';
import './index.less';
import { addtionalServicesList, massPriceThemeColors, packageIntroList, subTableData, headerData } from './data';
import NewPlanTable from '@/components/NewPlanTable/index';
import { Dialog, Button } from '@kzui/core';

export const block = genBlock('p-weixin-mass-price');

const WxMassPrice: React.FC<{}> = () => {
  const [dialogVisible, setDialogVisible] = React.useState(false);
  const [buyVisible, setBuyVisible] = React.useState(false);
  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO.mass.keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO.mass.description);
  }, []);

  return (
    <div className={block()}>
      <h1 className={block('title')}>公众号定价套餐</h1>
      <div className={block('main')}>
        <div className={block('package-intro-cards')}>
          {packageIntroList.map(item => (
            <div className={block('package-intro')}>
              <div className={block('package-intro-top-border')} style={{ background: massPriceThemeColors[item.type] }} />
              <img className={block('package-intro-logo')} src={item.logo} />
              <p className={block('package-intro-title')}>{item.title}</p>
              {item.price && (
                <p className={block('package-intro-price')}>
                  <span className={block('package-intro-price-empha')}>{item.price.year}</span>/年
                </p>
              )}
              {item.tip && <p className={block('package-intro-tip')}>{item.tip}</p>}
              <div className={block('package-intro-divider')} />
              <ul className={block('package-intro-features')}>
                {item.descriptions.map((desc, index) => (
                  <li className={block('package-intro-feature')}>
                    <span>{desc}</span>
                  </li>
                ))}
              </ul>
              <div className={block('package-intro-btn-wrap')}>
                {(item as any).btn && (
                  <a
                    className={block('package-intro-btn')}
                    style={{ background: massPriceThemeColors[item.type] }}
                    href={(item as any).btn.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => {
                      if (!(item as any).btn.link) e.preventDefault();

                      // handleToBuy(e)
                    }}
                  >
                    {(item as any).btn.text}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className={block('table-wrap')}>
          <NewPlanTable tableData={subTableData} headerData={{ headerData, rowThWidth: '639px', colWidth: '384px' }} />
        </div>
        <div className={block('desc')}>*接入公众号个数100元/个/年</div>
        <div className={block('desc')}>*最终解释权归快站所有</div>
        {/* <div className={block('additional-services')}>
          {addtionalServicesList.map(service => (
            <div className={block('add-service')}>
              <div className={block('add-service-title')}>{service.title}</div>
              {service.desc.map(descItem => (
                <p className={block('add-service-desc')} key={descItem}>{descItem}</p>
              ))}
              {service.price ? (
                <p className={block('add-service-price')}>
                  <span className={block('add-service-price-empha')}>{service.price}</span>元
                  <span>
                    /
                    {service.unit?.map((item, index) => (
                      <>
                        <span className={index == 0 ? block('add-service-price-empha') : ''}>{item}</span>
                      </>
                    ))}
                  </span>
                </p>
              ) : null}
              <a
                href={service.link}
                target="_blank"
                className={block('add-service-btn')}
                rel="noopener noreferrer"
                onClick={e => {
                  if (!service.link) {
                    e.preventDefault();
                  }
                  if (service.contactUs) {
                    setDialogVisible(true);
                  }
                  // handleToBuy(e)
                }}
              >
                {service.btnText}
              </a>
            </div>
          ))}
        </div> */}
        <Dialog hide={!dialogVisible} onClose={() => setDialogVisible(false)} className={block('stuff-dialog')} title={<span>&nbsp;</span>}>
          <div className={block('stuff-dialog-content')}>
            <p>如果还需要更高级的功能/定制，更极速稳定的群发</p>
            <p>可扫描下方工作人员二维码</p>
            <img src="https://pic.kuaizhan.com/g3/97/5a/b4d4-b39d-4c72-a9ca-f34abf5791d396/imageView/v1/thumbnail/200x200" alt="工作人员二维码" width={150} height={150} className={block('stuff-dialog-qrcode')} />
          </div>
        </Dialog>
        <Dialog
          hide={!buyVisible}
          onClose={() => setBuyVisible(false)}
          className={block('stuff-dialog')}
          title={<span>&nbsp;</span>}
          actions={[
            <Button type="confirm" size="large" onClick={() => setBuyVisible(false)}>
              确定
            </Button>,
          ]}
        >
          <div className={block('stuff-dialog-content')}>
            <p>线上支付将于10.28群发VIP上线后正式上线</p>
            <p>现可联系客服线下开通</p>
            <img src="https://pic.kuaizhan.com/g3/f8/9e/dde5-66aa-44ed-b014-fb35ad9cd83216/imageView/v1/thumbnail/200x200" alt="工作人员二维码" width={150} height={150} className={block('stuff-dialog-qrcode')} />
            <p>扫描上方二维码联系工作人员开通</p>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default WxMassPrice;
